import "./CtaSection.css";

function CtaSection({ onRequestProposal }) {
  return (
    <section className="cta" id="contact">
      <h2>Ready to upgrade your team’s skills?</h2>
      <p>
        Request a training proposal and let Trainosys help you design a
        professional learning program for your team.
      </p>
      <button
        type="button"
        className="cta-button"
        onClick={onRequestProposal}
      >
        Request Training Proposal
      </button>
    </section>
  );
}

export default CtaSection;
